import { render, staticRenderFns } from "./AlertForm.vue?vue&type=template&id=492b745c&"
import script from "./AlertForm.vue?vue&type=script&lang=ts&"
export * from "./AlertForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports